/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Grid, TableCell } from '@mui/material';
import TableWidgetV2 from '../TableWidgetV2';
import * as selectorsDocumentos from '../../../store/documento/reducer';
import * as actionsDocumentos from '../../../store/documento/actions';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import PdfViewerDialogV2 from '../filePreview/PdfViewerDialogV2';

const DocumentoContainerV2 = ({
  documentos,
  modulo,
  ativo,
  loadDocumentos,
  downloadDocumento,
  headerTitle,
  viewDocumentById,
  viewDocument,
  cleanViewDocumentById,
}) => {
  const renderRows = (s) => (
    <>
      <TableCell>{s.nome}</TableCell>
      <TableCell>{s.descricao}</TableCell>
      <TableCell>{s.modulo}</TableCell>
    </>
  );

  useEffect(() => {
    loadDocumentos(modulo, ativo);
  }, [loadDocumentos, modulo, ativo]);

  return (
    <>
      <Grid size={{ xs: 12 }} sx={{ pb: 3 }}>
        <TableWidgetV2
          rows={documentos}
          titles={['Nome', 'Descrição', 'Modulo']}
          headerTitle={headerTitle}
          showDelete={false}
          showEdit={false}
          showView={false}
          hasAdd={false}
          renderRows={renderRows}
          hasRowActions
          actions={[
            {
              key: 'view',
              onClick: (id) => {
                viewDocumentById(documentos.filter((d) => d.id === id)[0]);
              },
              icon: <PhotoCameraIcon fontSize="small" />,
            },
            {
              key: 'download',
              onClick: (id) => {
                const documento = documentos.filter((d) => d.id === id);
                downloadDocumento(documento.length > 0 ? documento[0] : {});
              },
              icon: <CloudDownloadIcon />,
            },
          ]}
        />
      </Grid>
      <PdfViewerDialogV2
        open={Boolean(viewDocument)}
        onClose={() => cleanViewDocumentById()}
        file={viewDocument ? viewDocument.file : null}
        title={viewDocument ? viewDocument.nome : ''}
        fileName={viewDocument ? viewDocument.nome : ''}
      />
    </>
  );
};

DocumentoContainerV2.propTypes = {
  downloadDocumento: PropTypes.func.isRequired,
  loadDocumentos: PropTypes.func.isRequired,
  documentos: PropTypes.array.isRequired,
  types: PropTypes.array,
  headerTitle: PropTypes.string,
};

DocumentoContainerV2.defaultProps = {
  headerTitle: 'Documentos',
  types: null,
};

const mapStateToProps = (state) => ({
  documentos: selectorsDocumentos.getDocumentos(state),
  viewDocument: selectorsDocumentos.getViewDocument(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsDocumentos,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DocumentoContainerV2));
